import { atom } from "recoil";

export const visibleConciergeState = atom<boolean>({
  key: "visibleConcierge",
  default: false,
});

export const visibleCouponListState = atom<boolean>({
  key: "visibleCouponList",
  default: false,
});

export const visibleCardState = atom<boolean>({
  key: "visibleCard",
  default: false,
});
